/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbClasseMatiereGridDto } from './FcbClasseMatiereGridDto';
import {
    FcbClasseMatiereGridDtoFromJSON,
    FcbClasseMatiereGridDtoFromJSONTyped,
    FcbClasseMatiereGridDtoToJSON,
} from './FcbClasseMatiereGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbClasseMatiereGridDtoPaginatedResults
 */
export interface FcbClasseMatiereGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbClasseMatiereGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbClasseMatiereGridDto>}
     * @memberof FcbClasseMatiereGridDtoPaginatedResults
     */
    results?: Array<FcbClasseMatiereGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbClasseMatiereGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbClasseMatiereGridDtoPaginatedResults interface.
 */
export function instanceOfFcbClasseMatiereGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbClasseMatiereGridDtoPaginatedResultsFromJSON(json: any): FcbClasseMatiereGridDtoPaginatedResults {
    return FcbClasseMatiereGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbClasseMatiereGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbClasseMatiereGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbClasseMatiereGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbClasseMatiereGridDtoPaginatedResultsToJSON(value?: FcbClasseMatiereGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbClasseMatiereGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

